module.exports = __webpack_public_path__ + "static/img/balance_pay1.847c7075.jpg";